"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function useTimedToggle(milliseconds) {
    const [isActive, setActive] = react_1.useState(false);
    const timeoutRef = react_1.useRef();
    function clearActiveTimeout() {
        if (timeoutRef.current) {
            window.clearTimeout(timeoutRef.current);
        }
    }
    function activate() {
        clearActiveTimeout();
        setActive(true);
        timeoutRef.current = window.setTimeout(() => {
            setActive(false);
        }, milliseconds);
    }
    // When the component is unmounted, make sure to clear the timeout.
    react_1.useEffect(() => clearActiveTimeout, []);
    return [isActive, activate];
}
exports.useTimedToggle = useTimedToggle;
//# sourceMappingURL=useTimedToggle.js.map